import React from 'react';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import { formatPhone } from 'lib/phoneUtil';
import { ContentWrapper, Subheading, Title } from 'components/Trials/styles';

import EnterCode from 'components/Trials/components/Verification/EnterCode';

const AccountVerificationContent = () => {
  const { phone } = useTrialsContext() || {};

  return (
    <ContentWrapper>
      <Title>Perfect! We just texted you a code.</Title>
      <Subheading>
        We sent a 4-digit code to{' '}
        <span style={{ fontWeight: '800' }}>
          {' '}
          {formatPhone(phone, 'NATIONAL')}
        </span>
        . Enter the code to continue setting up.
      </Subheading>

      <EnterCode />
    </ContentWrapper>
  );
};

export default AccountVerificationContent;
